module.exports = __webpack_public_path__ + "static/bomb-6932b011e319011cba31cc7df4f74ae4.mp3";